export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#C20A78] text-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 sm:py-24 text-center">
        <p className="font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.95]">
          Odiarte para encajar.
          <br />
          Quererte para ser feliz.
        </p>
        <p className="mt-8 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed text-white/90">
          Un proyecto narrativo que conecta una novela, una película y espacios de
          aprendizaje para cambiar cómo entendemos y prevenimos la violencia emocional
          y la baja autoestima en mujeres jóvenes, a partir del impacto emocional del
          cine.
        </p>
        <div className="mt-12 pt-8 border-t border-white/25">
          <p className="font-display text-2xl tracking-wide">Niñagordita</p>
          <p className="mt-2 text-sm text-white/70">© 2025 NG Films SAC</p>
        </div>
      </div>
    </footer>
  );
}
